// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import OrderLine from "./order-line.js"
import Photo from "./photo.js"
import Tenant from "./tenant.js"
import TenantPhotoProduct from "./tenant-photo-product.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_id": {
      "column": {
        "default": null,
        "name": "photo_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_photo_product_id": {
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_photo_product_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "OrderLinePhoto",
  "collectionKey": "order_line_photos",
  "collectionName": "order_line_photos",
  "i18nKey": "order_line_photo",
  "camelizedLower": "orderLinePhoto",
  "name": "OrderLinePhoto",
  "nameDasherized": "order-line-photo",
  "pluralName": "order_line_photos",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "orderable_id",
      "name": "order_line",
      "macro": "has_one",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photo",
      "macro": "belongs_to",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "has_one",
      "resource_name": "PhotoProduct",
      "through": "tenant_photo_product"
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "has_one",
      "resource_name": "Product",
      "through": "photo_product"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_id",
      "column": {
        "default": null,
        "name": "photo_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_photo_product_id",
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "OrderLine",
      "collectionName": "order_lines",
      "foreignKey": "orderable_id",
      "name": "order_line",
      "macro": "has_one",
      "resource_name": "OrderLine",
      "through": null
    },
    {
      "className": "Photo",
      "collectionName": "photos",
      "foreignKey": "photo_id",
      "name": "photo",
      "macro": "belongs_to",
      "resource_name": "Photo",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    }
  ],
  "paramKey": "order_line_photo",
  "primaryKey": "id"
}

/** Frontend model for OrderLinePhoto. */
export default class OrderLinePhoto extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoId() {
    return this.readAttributeUnderscore("photo_id")
  }

  /** @returns {boolean} */
  hasPhotoId() {
    const value = this.photoId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantPhotoProductId() {
    return this.readAttributeUnderscore("tenant_photo_product_id")
  }

  /** @returns {boolean} */
  hasTenantPhotoProductId() {
    const value = this.tenantPhotoProductId()

    return this._isPresent(value)
  }

  /** @returns {import("./order-line.js").default | null} */
  orderLine() {
    return this._readHasOneReflection({modelClass: OrderLine, reflectionName: "order_line"})
  }

  /** @returns {Promise<import("./order-line.js").default | null>} */
  loadOrderLine() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["orderable_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "order_line",
        model: this,
        modelClass: OrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order-line.js").default | null>} */
  ensureOrderLineLoaded() {
    return this.ensureAssociationLoaded("order_line")
  }

  /** @returns {import("./photo.js").default | null} */
  photo() {
    return this._readBelongsToReflection({modelClass: Photo, reflectionName: "photo"})
  }

  /** @returns {Promise<import("./photo.js").default | null>} */
  loadPhoto() {
    if (!("photoId" in this)) throw new Error("Foreign key method wasn't defined: photoId")

    const id = this.photoId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo",
        model: this,
        modelClass: Photo
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo.js").default | null>} */
  ensurePhotoLoaded() {
    return this.ensureAssociationLoaded("photo")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }

  /** @returns {import("./tenant-photo-product.js").default | null} */
  tenantPhotoProduct() {
    return this._readBelongsToReflection({modelClass: TenantPhotoProduct, reflectionName: "tenant_photo_product"})
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  loadTenantPhotoProduct() {
    if (!("tenantPhotoProductId" in this)) throw new Error("Foreign key method wasn't defined: tenantPhotoProductId")

    const id = this.tenantPhotoProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant_photo_product",
        model: this,
        modelClass: TenantPhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  ensureTenantPhotoProductLoaded() {
    return this.ensureAssociationLoaded("tenant_photo_product")
  }
}
